export const paletteGreen = {
  primary: {
    lighter: '#E0F2F1', // Very light teal
    light: '#4DB6AC',
    main: '#00695C', // Emerald/Teal 800 - Primary Brand Color
    dark: '#004D40',
    darker: '#2A6049', // El tono extra que hoy está hardcodeado
    contrastText: '#ffffff',
  },
  secondary: {
    lighter: '#E3F2FD',
    light: '#64B5F6',
    main: '#1565C0', // Blue 800 - Deep Ocean
    dark: '#0D47A1',
    contrastText: '#ffffff',
  },
  error: {
    light: '#EF5350',
    main: '#D32F2F',
    dark: '#C62828',
    contrastText: '#fff',
  },
  warning: {
    light: '#FFF9C4',
    main: '#FBC02D',
    dark: '#F57F17',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  success: {
    light: '#C8E6C9',
    main: '#2E7D32',
    dark: '#1B5E20',
    contrastText: '#fff',
  },
  info: {
    main: '#0288D1', 
    light: '#03A9F4', 
    dark: '#01579B', 
    contrastText: '#fff'
  },
  background: {
    default: '#F4F6F8', // Neutral grey-blue tint
    paper: '#FFFFFF',
    neutral: '#F3F4F6', // Para fondos secundarios y hovers sutiles
  },
  text: {
    primary: '#1F2937', // Gray 900
    secondary: '#4B5563', // Gray 700
    disabled: '#9CA3AF', // Gray 400
  },
  divider: '#E5E7EB',
  // Brand tokens — use these instead of hardcoded hex values
  brand: {
    main: '#2A6049',
    light: '#e8f5e9',
    lighter: '#f1f8e9',
    dark: '#1e4735',
    contrastText: '#ffffff',
    headerBg: '#00695C',     // = primary.main — para cabeceras de DataGrid
    headerText: '#ffffff',   // contraste blanco sobre headerBg
    rowHover: '#E8F5E9',     // tinte muy claro para hover de filas
  },
};
